module.exports = __webpack_public_path__ + "img/equipe_plan-de-travail2.f9f1c864.jpg";